export const BVOG_URL = 'https://www.bvog.at';
export const OFAKT_URL = 'https://ofakt.netlify.com';

export const BVOG_EMAIL_CONTACT_PAGE = 'post@bvog.at';
export const BVOG_EMAIL_API_URL = 'https://bbmr.webscience.at';

// APIs keys
export const GOOGLE_MAP_API_KEY = 'AIzaSyDY26g9ErMs4_W5PhKKwUeWeLhh3RkYoFc';
export const G00GLE_RECAPTCHA_API_KEY = '6LdfoqMUAAAAALfoUbFmX4ZmkNivs4FceUR-YrGK';
